import { Button, PlusIcon } from "melco-ui"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next";
import { useAddThread } from "../../hooks/threads/useAddThread";

export const AddThreadActionButton: React.FC = () => {

    const navigate = useNavigate()
    const addThreads = useAddThread();
    const { t } = useTranslation();
    return <>
        <Button
            icon={<PlusIcon />}
            onClick={async () => {

                let response = await addThreads();
                if (response && response.id)
                    navigate(`/system/managethreads/${response.id!}`)
                console.log(response)
            }}
            type="primary"
        >
            {t('managethreads.actions.add.button.title')}

        </Button>
    </>
}